import { apiFetch } from "./api";

export const saveEditObjetives = async (values) => {
    const obj = {
        method: 'POST',
        body: {
            objectives: values,
            option: 'save_edit_objectives',
        }
    }

    const response = await apiFetch(obj);

    return response;
};
